import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';

import { realtorConstants, realtorModels } from '..';

export const useRealtorBalance = (props?: { page?: number | null; size?: number | null; search?: string | null }) =>
  useQuery<Pagination<realtorModels.IRealtorBalance>>({
    queryKey: [realtorConstants.queryKeys.REALTOR_BALANCE, props],
    queryFn: async () => {
      const res = await $api.post('/v1/realtor/balance', {
        page: 1,
        size: 10,
        ...props
      });

      return res?.data?.data;
    }
  });
